var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLongLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2962 12.2896C0.903856 12.6783 0.900906 13.3115 1.28961 13.7038C1.67831 14.0961 2.31146 14.0991 2.7038 13.7104L1.2962 12.2896ZM11.7145 11.9087L12.4199 11.1999L11.7145 11.9087ZM11.8558 11.9085L11.1477 11.2024L11.8558 11.9085ZM7.34734 7.70226L8.05114 8.41265L7.34734 7.70226ZM7.48826 7.70242L6.78283 8.4112L7.48826 7.70242ZM2.7038 13.7104L8.05114 8.41265L6.64353 6.99187L1.2962 12.2896L2.7038 13.7104ZM6.78283 8.4112L11.0091 12.6175L12.4199 11.1999L8.1937 6.99365L6.78283 8.4112ZM12.564 12.6146L17.5831 7.5811L16.1669 6.1689L11.1477 11.2024L12.564 12.6146ZM11.0091 12.6175C11.4394 13.0458 12.1353 13.0445 12.564 12.6146L11.1477 11.2024C11.4985 10.8506 12.0679 10.8495 12.4199 11.1999L11.0091 12.6175ZM8.05114 8.41265C7.69979 8.76075 7.13338 8.7601 6.78283 8.4112L8.1937 6.99365C7.76524 6.56721 7.07296 6.56642 6.64353 6.99187L8.05114 8.41265Z",
    fill: "#05B681"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6H17.65C17.7052 6 17.75 6.04477 17.75 6.1V11.25",
    stroke: "#05B681",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongLight);
export default __webpack_public_path__ + "static/media/long-light.639469d371fab2985dbc0fd236143b2d.svg";
export { ForwardRef as ReactComponent };